<sd-modal>
  <div class="cx-dialog-header modal-header">
    <div class="cx-dialog-title modal-title">Фильтры</div>
  </div>
  <div class="wrapper">
    <div class="filters">
      <ng-container
        *ngTemplateOutlet="variant; context: { value: orderUserProfileFilter.ALL, title: 'все заказы' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="variant; context: { value: orderUserProfileFilter.B2C, title: 'заказы на физ. лицо' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="variant; context: { value: orderUserProfileFilter.B2B, title: 'заказы на юр. лицо' }"
      ></ng-container>

      <ng-template let-value="value" let-title="title" #variant>
        <sd-radio name="orderTypeFilter" [formControl]="orderUserProfileFilterControl" [value]="value">
          <span class="title">{{ title }}</span>
        </sd-radio>
      </ng-template>
    </div>
  </div>
</sd-modal>
